function handleStickyPromoRibbon() {
  let intervalId = window.__stickyPromoIntervalId;

  if (!intervalId) {
    const announcements = [
      /*{
        message:
          "<strong>Free Shipping</strong> on US orders <strong>over $75</strong>",
        link: "https://www.silverts.com/pages/shipping-prices",
      },
      {
        message:
          "<strong>Free Rush Shipping</strong> on US orders <strong>over $150</strong>",
        link: "https://www.silverts.com/pages/shipping-prices",
      },*/
    ];

    const announcementBars = document.querySelectorAll(".announcement-bar[data-announcements]");
    console.log("Announcement Bars: %o", announcementBars);
    if (announcementBars.length > 0) {
      while (announcements.length > 0) announcements.pop();
      announcementBars.forEach(bar => {
        console.log("Announcement bar: %o", bar);
        let newAnnouncements = JSON.parse(bar.attributes["data-announcements"].value);
        console.log("Announcement bar contents: %o", newAnnouncements);
        newAnnouncements.forEach(element => { announcements.push(element) });
      });
    }
    console.log("Announcements: %o", announcements);

    const shopbar = document.querySelector(".shop-bar");
    if (shopbar != null) {
      let shopbartext = document.querySelector(".shop-bar a.shop-bar__link strong");
      if (shopbartext == null) shopbartext = document.querySelector(".shop-bar a.shop-bar__link");
      let shopbarbutton = document.querySelector(".shop-bar a.shop-bar__button");
      if (shopbartext != null && shopbarbutton != null) {
        let salemessage = {
          message: shopbartext.innerHTML,
          link: shopbarbutton.href,
          buttonText: shopbarbutton.textContent
        };
        console.log("new salemessage: %o", salemessage);
        announcements.push(salemessage);
      }
    }

    const rotation = document.querySelector(".banner-rotation");
    if (!rotation) return;
    const mobile = rotation.querySelector(".announcement-bar__message-mobile");
    const desktop = rotation.querySelector(
      ".announcement-bar__message-desktop"
    );
    let idx = 0;

    function showAnnouncement(i) {
      rotation.classList.remove("fade-in");
      rotation.classList.add("fade-out");
      setTimeout(() => {
        mobile.innerHTML = announcements[i].message;
        desktop.innerHTML = announcements[i].message;
        rotation.setAttribute("href", announcements[i].link);

        const arrow = rotation
          .querySelector(".announcement-bar__message")
          ?.querySelector(".message-arrow");

        if (i === 2) {
          if (arrow) arrow.textContent = announcements[i].buttonText;
        } else {
          if (arrow) arrow.textContent = "see details";
        }

        rotation.classList.remove("fade-out");
        rotation.classList.add("fade-in");
      }, 400);
    }

    const style = document.createElement("style");
    style.innerHTML = `
        .announcement-bar__message-mobile, .announcement-bar__message-desktop { font-weight: normal !important; text-transform: none !important; }
        .shopify-section.shopify-section-group-header-group.announcement-bar-section { position: sticky; top: 0; }
        .utility-bar.color-scheme-6.gradient.utility-bar--bottom-border { position: sticky; }
        .banner-rotation.fade-in { opacity: 1; transition: opacity 0.4s; }
        .banner-rotation.fade-out { opacity: 0; transition: opacity 0.4s; }
      `;
    document.head.appendChild(style);

    showAnnouncement(idx);
    intervalId = setInterval(() => {
      idx = (idx + 1) % announcements.length;
      showAnnouncement(idx);
    }, 4000);
    window.__stickyPromoIntervalId = intervalId;

    const announcementBar = document.querySelector(
      ".shopify-section.shopify-section-group-header-group.announcement-bar-section"
    );
    const header = document.querySelector(
      ".shopify-section.shopify-section-group-header-group.section-header"
    );

    if (true || announcementBar && header) {
      const extraStyle = document.createElement("style");
      extraStyle.innerHTML = `
					.shopify-section-header-sticky {
						/*top: 45px;*/
            top: calc(45px + clamp(15px, 4vw, 24px) * 2.2 + 8px);
					}
					.shopify-section-header-hidden {
						top: calc(-1 * var(--header-height)) !important;
					}
          @media screen and (min-width:501px) {
            .shopify-section-header-sticky {
              top: calc(45px + clamp(15px, 4vw, 24px) * 2.4 + 14px);
            }
          }
				`;
      document.head.appendChild(extraStyle);
    }
  }
}

handleStickyPromoRibbon();
